import axios from 'axios'
import CryptoJS from 'crypto-js'

const baseURL = '/api'

class Request {
  constructor () {
    // 默认加密配置
    this.cryptoConfig = {
      mode: 'ECB', // 使用ECB模式
      pad: 'Pkcs7', // 使用PKCS7填充
      key: '$e$Pp7h80F5k4D3s', // 密钥初始为空，将从app.vue设置
      keyType: 'Utf8', // 密钥编码类型
      iv: '', // ECB模式不需要IV
      ivType: 'Utf8', // IV编码类型
      isBase64: true // 使用Base64输出
    }

    // 存储Vue实例引用
    this.vueInstance = null
  }

  // 设置Vue实例
  setVueInstance (vueInstance) {
    this.vueInstance = vueInstance
    // 从Vue实例中获取密钥
    if (vueInstance && vueInstance.base) {
      this.cryptoConfig.key = vueInstance.base
    }
  }

  // AES加密方法
  encryptData (data) {
    // 如果没有密钥则不加密
    if (!this.cryptoConfig.key) return data

    const { mode, pad, key, keyType, iv, ivType, isBase64 } = this.cryptoConfig

    try {
      const cryptoKey = CryptoJS.enc[keyType].parse(key)
      const cfg = {
        mode: CryptoJS.mode[mode],
        padding: CryptoJS.pad[pad]
      }

      if (mode !== 'ECB' && iv) {
        cfg.iv = CryptoJS.enc[ivType].parse(iv)
      }

      // 如果数据是对象，先转为JSON字符串
      const dataStr = typeof data === 'object' ? JSON.stringify(data) : data

      const encrypted = CryptoJS.AES.encrypt(dataStr, cryptoKey, cfg)
      return encrypted.ciphertext.toString(isBase64 ? CryptoJS.enc.Base64 : CryptoJS.enc.Hex)
    } catch (error) {
      console.error('加密失败:', error)
      return data
    }
  }

  // AES解密方法
  decryptData (encryptedData) {
    // 如果没有密钥则不解密
    if (!this.cryptoConfig.key) return encryptedData

    const { mode, pad, key, keyType, iv, ivType, isBase64 } = this.cryptoConfig

    try {
      const cryptoKey = CryptoJS.enc[keyType].parse(key)
      const cfg = {
        mode: CryptoJS.mode[mode],
        padding: CryptoJS.pad[pad]
      }

      if (mode !== 'ECB' && iv) {
        cfg.iv = CryptoJS.enc[ivType].parse(iv)
      }

      // 处理输入数据
      const cryptoData = isBase64
        ? encryptedData
        : CryptoJS.enc.Base64.stringify(CryptoJS.enc.Hex.parse(encryptedData))

      const decrypt = CryptoJS.AES.decrypt(cryptoData, cryptoKey, cfg)
      const result = CryptoJS.enc.Utf8.stringify(decrypt)

      // 尝试解析为JSON对象，如果不是JSON则返回原始字符串
      try {
        return JSON.parse(result)
      } catch {
        return result
      }
    } catch (error) {
      console.error('解密失败:', error)
      return encryptedData
    }
  }

  request (url, method, data, headers) {
    if (method === 'post') {
      headers = {
        'Content-Type': 'application/json;charset=UTF-8',
        ...headers
      }
    }

    // 在发送前加密数据
    let processedData = data
    if (this.cryptoConfig.key && method === 'post') {
      processedData = this.encryptData(data)
    }

    return new Promise((resolve, reject) => {
      axios({
        url: `${baseURL}/${url}`,
        method,
        params: method === 'get' ? data : {},
        data: method === 'post' ? JSON.stringify({ reqData: processedData }) : {},
        headers
      }).then(res => {
        if (res.status === 200) {
          // 解密逻辑增强
          let decryptedData = res.data
          if (this.cryptoConfig.key) {
            // 如果data是加密字符串，直接解密
            if (typeof res.data === 'string') {
              decryptedData = this.decryptData(res.data)
              try {
                decryptedData = JSON.parse(decryptedData) // 尝试解析为JSON
              } catch (e) {
                // 如果不是JSON，保持原样
              }
              // eslint-disable-next-line brace-style
            }
            // 如果data是对象且包含加密字段
            else if (res.data.data && typeof res.data.data === 'string') {
              const decrypted = this.decryptData(res.data.data)
              decryptedData = {
                ...res.data,
                data: JSON.parse(decrypted) // 假设data字段是加密的JSON字符串
              }
            }
          }
          resolve(decryptedData)
        }
      }).catch(error => {
        reject(error)
      })
    })
  }

  get (url, data = {}, headers = {}) {
    return this.request(url, 'get', data, headers)
  }

  post (url, data = {}, headers = {}) {
    return this.request(url, 'post', data, headers)
  }
}

const requestInstance = new Request()
export default requestInstance
